var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 18,
    viewBox: "0 0 12 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.416626 18L0.166626 15.8L3.01663 7.95C3.26663 8.18333 3.53746 8.37917 3.82913 8.5375C4.12079 8.69583 4.43329 8.81667 4.76663 8.9L2.01663 16.45L0.416626 18ZM10.9166 18L9.31663 16.45L6.56663 8.9C6.89996 8.81667 7.21246 8.69583 7.50413 8.5375C7.79579 8.37917 8.06663 8.18333 8.31663 7.95L11.1666 15.8L10.9166 18ZM5.66663 8C4.83329 8 4.12496 7.70833 3.54163 7.125C2.95829 6.54167 2.66663 5.83333 2.66663 5C2.66663 4.35 2.85413 3.77083 3.22913 3.2625C3.60413 2.75417 4.08329 2.4 4.66663 2.2V0H6.66663V2.2C7.24996 2.4 7.72913 2.75417 8.10413 3.2625C8.47913 3.77083 8.66663 4.35 8.66663 5C8.66663 5.83333 8.37496 6.54167 7.79163 7.125C7.20829 7.70833 6.49996 8 5.66663 8ZM5.66663 6C5.94996 6 6.18746 5.90417 6.37913 5.7125C6.57079 5.52083 6.66663 5.28333 6.66663 5C6.66663 4.71667 6.57079 4.47917 6.37913 4.2875C6.18746 4.09583 5.94996 4 5.66663 4C5.38329 4 5.14579 4.09583 4.95413 4.2875C4.76246 4.47917 4.66663 4.71667 4.66663 5C4.66663 5.28333 4.76246 5.52083 4.95413 5.7125C5.14579 5.90417 5.38329 6 5.66663 6Z",
    fill: "#8E8E8E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompass);
export default __webpack_public_path__ + "static/media/compass.46eccc7150c1de49f123925ad4d470a8.svg";
export { ForwardRef as ReactComponent };